import React from 'react';
import Button from '../../Components/Button/Button';
import { Link } from  "react-router-dom"
import "./AccountSuccess.css"
import img from "../../assets/img/Group 39 (002).png";
import { useParams } from 'react-router-dom';

function AccountSuccess() {

  const { CustomerNumber , AccountNUBAN} = useParams()
  return (
    <div className ="accountsucess">
      
       <div className = "accountsucess_content">
        <div className = "accountsucess_text">
          <h4> Account Opening Successful </h4>
          <p>Your Business Account has been opened Successfully</p>
          <p>Thank you for choosing Providus Bank</p>
          <div className = 'accountsucess_number'> Your Customer Id is <p>{CustomerNumber}</p></div>
          <div className = 'accountsucess_number'>Your Account Number is <p>{AccountNUBAN}</p></div>
          <Link to="/">
             <Button content = "Back Home"/>
          </Link>
        </div>
        <div >
          <img className = "success_img" src = {img} alt ="loadingimg"></img>
        </div>
       </div>
    </div>
  );
}

export default AccountSuccess;
